import { FormControl, makeStyles, MenuItem, Select } from "@material-ui/core";
import React, { useEffect } from "react";
import { GetCookies, SetCookies } from "../../../_helpers/Cookies";
import { loadCachedTranslations, ensureLanguageCached, fetchAndCacheTranslations } from "../../../_partials/utilities/remoteTranslations";

export default function MultiLingual({ themeData,translationsVersion }) {
    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            borderColor: "#000000",
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        menuItemScroll: {
            maxHeight: "200px",
            overflowY: "auto",
            backgroundColor: themeData?.nav_bar_color
                ? themeData?.nav_bar_color
                : "#fff",
        },
        select: {
            "&.Mui-disabled": {
                backgroundColor: "#e0e0e0",
                cursor: "not-allowed !important",
            },
        },
        menuItem: {
            "&:hover": {},
            "&.Mui-selected": {},
        },
    }));

    const classes = useStyles();
    const [language, setLanguage] = React.useState("en");
    const [languageOptions, setLanguageOptions] = React.useState([
        { label: "English", value: "en" },
    ]);

    const handleChange = async (event) => {
        const value = event.target.value;
        await ensureLanguageCached(value); // make sure S3 data is in localStorage before reload
        setLanguage(value);
        SetCookies("language", value);
        window.location.reload(false);
    };

    useEffect(() => {
        GetCookies("language").then((response) => {
            if (response) {
                setLanguage(response);
            } else {
                setLanguage("en");
                SetCookies("language", "en");
            }
        });

        const cached = loadCachedTranslations();
        if (cached?.languages) {
            setLanguageOptions(cached.languages);
        }
        // no own fetch — Routes.js already triggers it, translationsVersion will fire this effect again once it's cached
    }, [translationsVersion]);
    console.log(translationsVersion,"translationsVersion")
    return (
        <div className="MultiLingual">
            <FormControl className={classes.formControl}>
                <Select
                    classes={{ root: classes.select }}
                    labelId="MultiLingual"
                    id="MultiLingual"
                    value={language}
                    onChange={handleChange}
                    variant="outlined"
                    margin="dense"
                    MenuProps={{
                        classes: {
                            paper: classes.menuItemScroll,
                        },
                    }}
                >
                    {languageOptions.map((opt) => (
                        <MenuItem
                            key={opt.value}
                            className={`c-header-menu ${classes.menuItem}`}
                            value={opt.value}
                        >
                            {opt.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}